module.exports = __webpack_public_path__ + "static/media/BannerCongresoES.52e84198.jpg";